import { Box, Stack, Typography } from "@mui/material";
import { LIMIT_UNIT_LABEL } from "@src/constants/subscription-constants";
import { yellow, ExclamationMarkCircleFillIcon } from "@flat-ui";
import {
  DEFAULT_BOLD_TEXT_FONT_WEIGHT,
  DEFAULT_INPUT_FONT_SIZE,
  DEFAULT_TEXT_FONT_WEIGHT,
} from "@styles/common-styles";
import { NumberUtils } from "@stellar/utils";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { hasExceededQuota } from "@hooks/subscription/use-usage-metrics";

interface Props {
  /** Subscription limit */
  limit: FaroCoreApiTypes.LimitQuota;

  /** Optional action or component rendered on the right side */
  actionComponent?: React.ReactNode;
}

/** Details of a subscription limit */
export function SubscriptionLimit({
  limit,
  actionComponent,
}: Props): JSX.Element {
  const limitNameDisplay = LIMIT_UNIT_LABEL[limit.identifier];
  const shouldShowWarning = hasExceededQuota(limit);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Typography
        sx={{
          gap: 1,
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
          lineHeight: "30px",
        }}
      >
        {shouldShowWarning && (
          <ExclamationMarkCircleFillIcon
            sx={{ color: yellow[500], width: "20px", height: "20px" }}
          />
        )}
        {`${NumberUtils.formatNumberWithSpaces(limit.current ?? 0)}`}
        <Box
          component="span"
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            fontWeight: DEFAULT_TEXT_FONT_WEIGHT,
            lineHeight: "20px",
          }}
        >
          {`/ ${NumberUtils.formatNumberWithSpaces(
            limit.limit
          )} ${limitNameDisplay}`}
        </Box>
      </Typography>

      {actionComponent}
    </Stack>
  );
}
